export const UA_CLASS = {
  init: function () {
    const ua = window.navigator.userAgent.toLowerCase()
    const className = this.getBrowserClassName(ua)

    $('body').addClass(className)
  },
  getBrowserClassName: function (ua) {
    if (ua.includes('msie') || ua.includes('trident')) {
      return 'browse-ie'
    } else if (ua.includes('edge')) {
      return 'browse-edge'
    } else if (ua.includes('chrome')) {
      return 'browse-chrome'
    } else if (ua.includes('safari')) {
      return 'browse-safari'
    } else if (ua.includes('firefox')) {
      return 'browse-firefox'
    } else if (ua.includes('opera')) {
      return 'browse-opera'
    } else {
      return ''
    }
  },
}
